module.exports = __webpack_public_path__ + "img/pic_number_40.cd52be6c.png";